import i18n from 'modules/core/lib/i18n'

export const employeeTypes = (): { [key: string]: string } => ({
  employee: i18n.t('contract_versions.forms.contract_extra_information.fr_employee_types.employee'),
  interim: i18n.t('contract_versions.forms.contract_extra_information.fr_employee_types.interim'),
  freelance: i18n.t(
    'contract_versions.forms.contract_extra_information.fr_employee_types.freelance'
  ),
  agent_de_maitrise: i18n.t(
    'contract_versions.forms.contract_extra_information.fr_employee_types.agent_de_maitrise'
  ),
  apprenti: i18n.t('contract_versions.forms.contract_extra_information.fr_employee_types.apprenti'),
  article_36: i18n.t(
    'contract_versions.forms.contract_extra_information.fr_employee_types.article_36'
  ),
  cadres: i18n.t('contract_versions.forms.contract_extra_information.fr_employee_types.cadres'),
  dirigeant: i18n.t(
    'contract_versions.forms.contract_extra_information.fr_employee_types.dirigeant'
  ),
  etam: i18n.t('contract_versions.forms.contract_extra_information.fr_employee_types.etam'),
  ouvriers: i18n.t('contract_versions.forms.contract_extra_information.fr_employee_types.ouvriers'),
  saisonnier: i18n.t(
    'contract_versions.forms.contract_extra_information.fr_employee_types.saisonnier'
  ),
  vrp: i18n.t('contract_versions.forms.contract_extra_information.fr_employee_types.vrp'),
  contrat_professionnalisation: i18n.t(
    'contract_versions.forms.contract_extra_information.fr_employee_types.contrat_professionnalisation'
  ),
  extra: i18n.t('contract_versions.forms.contract_extra_information.fr_employee_types.extra'),
  stagiaire: i18n.t(
    'contract_versions.forms.contract_extra_information.fr_employee_types.stagiaire'
  ),
})
